// extracted by mini-css-extract-plugin
export default {"root":"_1XCWJ","link-overlay":"_25MnG","linkOverlay":"_25MnG"};